module.exports = __webpack_public_path__ + "static/media/planning_documents.72eaf776.jpg";